import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SetupSearch } from 'areas/shared/pages/setup';
import { SearchBox } from 'fw/forms';
import { StatusFilter } from 'areas/shared/controls'
import * as API from 'modules/app/API'

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
            statusFilter: true
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'news' }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={4}>
                    <SearchBox
                        name="searchText"
                        placeholder="Search news..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="news" />
                </Col>
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/newsSetup/Search.js